// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"538":"0fb88872471e7ffe","888":"50a44579b2292c11"}[chunkId] + ".css";
};